/* =============================================================================
   Furniselan — product page gallery
   ============================================================================= */
(function () {
  'use strict';

  var FS = window.FS, qs = FS.qs, qsa = FS.qsa, once = FS.once;

  window._isInitialProductLoad = true;
  function clearInitialLoad() {
    window._isInitialProductLoad = false;
  }
  if (document.readyState === 'complete') {
    setTimeout(clearInitialLoad, 800);
  } else {
    window.addEventListener('load', function () {
      setTimeout(clearInitialLoad, 800);
    });
  }
  ['touchstart', 'mousedown', 'keydown', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, clearInitialLoad, { once: true, passive: true });
  });

  function slides(gallery) { return qsa('[data-media-id]', qs('[data-gallery-stage]', gallery)); }
  function thumbs(gallery) { return qsa('[data-thumb]', gallery); }

  function visibleSlides(gallery) {
    return slides(gallery).filter(function (s) {
      return !s.hidden && s.style.display !== 'none';
    });
  }

  function updateNavVisibility(gallery) {
    if (!gallery) return;
    var vSlides = visibleSlides(gallery);
    var prevBtn = qs('[data-gallery-prev]', gallery);
    var nextBtn = qs('[data-gallery-next]', gallery);
    var show = vSlides.length > 1;
    if (prevBtn) prevBtn.style.display = show ? '' : 'none';
    if (nextBtn) nextBtn.style.display = show ? '' : 'none';
  }

  function stepMedia(gallery, direction) {
    if (!gallery) return;
    var vSlides = visibleSlides(gallery);
    if (vSlides.length < 2) return;
    var curIdx = 0;
    for (var i = 0; i < vSlides.length; i++) {
      if (vSlides[i].classList.contains('is-active')) {
        curIdx = i;
        break;
      }
    }
    var nextIdx = (curIdx + direction + vSlides.length) % vSlides.length;
    window._isInitialProductLoad = false;
    selectMedia(gallery, vSlides[nextIdx].dataset.mediaId, true);
  }

  function selectMedia(gallery, mediaId, allowThumbScroll) {
    if (!gallery || mediaId == null) return;
    mediaId = String(mediaId);
    var found = false;
    slides(gallery).forEach(function (s) {
      var on = s.dataset.mediaId === mediaId;
      if (on) {
        found = true;
        s.classList.add('is-active');
        s.hidden = false;
        var zSrc = s.getAttribute('data-zoom-src');
        if (zSrc) {
          var pImg = new Image();
          pImg.src = zSrc;
        }
      } else {
        s.classList.remove('is-active');
      }
    });
    if (!found) return;
    thumbs(gallery).forEach(function (t) {
      var isT = t.dataset.thumb === mediaId;
      t.classList.toggle('is-active', isT);
      if (allowThumbScroll && isT && !window._isInitialProductLoad) {
        var rail = t.closest('.rail, [data-gallery-thumbs]');
        if (rail) {
          if (t.offsetLeft < rail.scrollLeft) {
            rail.scrollTo({ left: t.offsetLeft, behavior: 'smooth' });
          } else if (t.offsetLeft + t.offsetWidth > rail.scrollLeft + rail.clientWidth) {
            rail.scrollTo({ left: t.offsetLeft + t.offsetWidth - rail.clientWidth, behavior: 'smooth' });
          }
        }
      }
    });
    updateNavVisibility(gallery);
  }

  function selectFirstVisible(gallery) {
    if (!gallery) return;
    var all = slides(gallery);
    var first = all.filter(function (s) { return !s.hidden; })[0];
    if (!first && all.length > 0) {
      all.forEach(function (s) { s.hidden = false; });
      thumbs(gallery).forEach(function (t) { t.hidden = false; });
      first = all[0];
    }
    if (first) selectMedia(gallery, first.dataset.mediaId);
  }

  function galleryFor(el) { return el ? el.closest('[data-gallery]') || qs('[data-gallery]') : qs('[data-gallery]'); }

  var ZOOM = 2;


  function initZoom(gallery, stage) {
    if (!once(stage, 'GalleryZoom')) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var lens = document.createElement('span');
    lens.className = 'product__zoom-lens';
    lens.hidden = true;
    stage.appendChild(lens);

    var pane = document.createElement('div');
    pane.className = 'product__zoom-pane';
    pane.hidden = true;
    gallery.appendChild(pane);

    function activeImg() { return qs('.product__slide.is-active [data-zoomable], .product__slide.is-active img', stage); }

    function updateZoomBackground() {
      var img = activeImg();
      if (!img) return;
      var slide = img.closest('.product__slide');
      var zoomSrc = (slide && slide.getAttribute('data-zoom-src')) || img.currentSrc || img.src || img.getAttribute('src');
      if (zoomSrc && pane._currentZoomSrc !== zoomSrc) {
        pane._currentZoomSrc = zoomSrc;
        pane.style.backgroundImage = 'url("' + zoomSrc + '")';
      }
    }

    function move(e) {
      if (stage.classList.contains('is-dragging')) {
        lens.hidden = true;
        pane.hidden = true;
        return;
      }
      var img = activeImg();
      if (!img) return;
      var r = img.getBoundingClientRect();
      if (!r.width || !r.height) return;

      var paneR = pane.getBoundingClientRect();
      var lensW = Math.min(r.width, (paneR.width || r.width) / ZOOM);
      var lensH = Math.min(r.height, (paneR.height || r.height) / ZOOM);
      lens.style.width = lensW + 'px';
      lens.style.height = lensH + 'px';

      var x = e.clientX - r.left - lensW / 2;
      var y = e.clientY - r.top - lensH / 2;
      x = Math.max(0, Math.min(x, r.width - lensW));
      y = Math.max(0, Math.min(y, r.height - lensH));

      var stageR = stage.getBoundingClientRect();
      lens.style.left = (r.left - stageR.left + x) + 'px';
      lens.style.top = (r.top - stageR.top + y) + 'px';

      pane.style.backgroundSize = (r.width * ZOOM) + 'px ' + (r.height * ZOOM) + 'px';
      pane.style.backgroundPosition = '-' + (x * ZOOM) + 'px -' + (y * ZOOM) + 'px';
    }

    stage.addEventListener('mouseenter', function (e) {
      if (small.matches) return;
      var img = activeImg();
      if (!img) return;
      var r = img.getBoundingClientRect();
      var gR = gallery.getBoundingClientRect();
      var vw = document.documentElement.clientWidth;
      var avail = vw - (gR.right + 20) - 12;   
      var inner = avail < 320;                
      pane.style.width = (inner ? r.width : Math.min(r.width, avail)) + 'px';
      pane.style.height = r.height + 'px';
      pane.style.top = (r.top - gR.top) + 'px';
      pane.style.left = inner ? (r.left - gR.left) + 'px' : '';
      pane.style.pointerEvents = 'none';
      lens.hidden = inner; pane.hidden = false;
      updateZoomBackground();
      move(e);
    });
    stage.addEventListener('mousemove', move);
    stage.addEventListener('mouseleave', function () { lens.hidden = true; pane.hidden = true; });
  }

  /* ---------------------------------------------------------------------------
     Mobile viewer (994px and below). Tapping the photo opens it full screen:
     ------------------------------------------------------------------------- */
  var small = window.matchMedia('(max-width: 994px)');
  var MAX_SCALE = 4;
  var ICONS = {
    zoomIn: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5"/></svg>',
    zoomOut: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m15.5 15.5 5 5M7.5 10.5h6"/></svg>',
    close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 5.5l13 13M18.5 5.5l-13 13"/></svg>',
    prev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 7.5 12l7.5 7.5"/></svg>',
    next: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 16.5 12 9 19.5"/></svg>'
  };
  var V = null; // the one viewer, built on first open

  function str(key, fallback) { return (FS.T.strings && FS.T.strings[key]) || fallback; }

  function viewerItems(gallery) {
    return slides(gallery).filter(function (s) { return !s.hidden && qs('[data-zoomable]', s); }).map(function (s) {
      var img = qs('[data-zoomable]', s);
      var thumb = qs('[data-thumb="' + s.dataset.mediaId + '"] img', gallery);
      var w = +img.getAttribute('width'), h = +img.getAttribute('height');
      return {
        id: s.dataset.mediaId,
        src: s.dataset.zoomSrc || img.currentSrc || img.src,
        preview: img.currentSrc || '',
        thumb: thumb ? (thumb.currentSrc || thumb.src) : (img.currentSrc || img.src),
        alt: img.alt || '',
        ratio: (w && h) ? w / h : (img.naturalWidth / img.naturalHeight) || 1
      };
    });
  }

  function buildViewer() {
    var el = document.createElement('div');
    el.className = 'media-viewer';
    el.hidden = true;
    el.setAttribute('inert', '');
    el.dataset.overlayHidden = 'true';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', str('mediaViewer', 'Image viewer'));
    el.innerHTML =
      '<div class="media-viewer__frame"><img class="media-viewer__img" alt="" draggable="false"></div>' +
      '<div class="media-viewer__bar">' +
        '<button type="button" class="media-viewer__btn" data-mv-zoom aria-pressed="false">' + ICONS.zoomIn + '</button>' +
        '<button type="button" class="media-viewer__btn" data-mv-close>' + ICONS.close + '</button>' +
      '</div>' +
      '<button type="button" class="media-viewer__btn media-viewer__nav media-viewer__nav--prev" data-mv-prev>' + ICONS.prev + '</button>' +
      '<button type="button" class="media-viewer__btn media-viewer__nav media-viewer__nav--next" data-mv-next>' + ICONS.next + '</button>' +
      '<div class="media-viewer__thumbs" data-mv-thumbs></div>';
    document.body.appendChild(el);

    V = {
      el: el, frame: qs('.media-viewer__frame', el), img: qs('.media-viewer__img', el),
      zoomBtn: qs('[data-mv-zoom]', el), strip: qs('[data-mv-thumbs]', el),
      items: [], index: 0, gallery: null, open: false, token: null,
      s: 1, x: 0, y: 0, box: null, pointers: {}, gesture: null, tap: null
    };
    V.zoomBtn.setAttribute('aria-label', str('zoom', 'Zoom image'));
    qs('[data-mv-close]', el).setAttribute('aria-label', str('close', 'Close'));
    qs('[data-mv-prev]', el).setAttribute('aria-label', str('prev', 'Previous'));
    qs('[data-mv-next]', el).setAttribute('aria-label', str('next', 'Next'));

    V.zoomBtn.addEventListener('click', function () { toggleZoom(); });
    qs('[data-mv-close]', el).addEventListener('click', closeViewer);
    qs('[data-mv-prev]', el).addEventListener('click', function () { show(V.index - 1); });
    qs('[data-mv-next]', el).addEventListener('click', function () { show(V.index + 1); });

    el.addEventListener('pointerdown', onPointerDown);
    el.addEventListener('pointermove', onPointerMove);
    el.addEventListener('pointerup', onPointerUp);
    el.addEventListener('pointercancel', onPointerUp);
    el.addEventListener('click', onTap);
    el.addEventListener('keydown', onKey);
    window.addEventListener('resize', function () { if (V.open) { layout(); reset(false); } });
    // Escape goes through FS.Overlay.closeAll(), which has already hidden us.
    document.addEventListener('fs:escape', function () { if (V.open) afterClose(); });
  }

  /** Size the photo to fit the frame (same box whichever resolution is loaded). */
  function layout() {
    var item = V.items[V.index];
    if (!item) return;
    var fr = V.frame.getBoundingClientRect();
    var w = Math.min(fr.width, fr.height * item.ratio), h = w / item.ratio;
    V.img.style.width = w + 'px';
    V.img.style.height = h + 'px';
    V.box = { w: w, h: h, cx: fr.left + fr.width / 2, cy: fr.top + fr.height / 2, vw: V.el.clientWidth, vh: V.el.clientHeight };
  }

  function apply(animate) {
    var zoomed = V.s > 1.01;
    V.img.classList.toggle('is-settling', !!animate);
    V.img.style.transform = 'translate3d(' + V.x + 'px,' + V.y + 'px,0) scale(' + V.s + ')';
    if (zoomed !== V.el.classList.contains('is-zoomed')) {
      V.el.classList.toggle('is-zoomed', zoomed);
      V.zoomBtn.innerHTML = zoomed ? ICONS.zoomOut : ICONS.zoomIn;
      V.zoomBtn.setAttribute('aria-pressed', String(zoomed));
    }
  }

  function reset(animate) { V.s = 1; V.x = 0; V.y = 0; apply(animate); }

  /** Keep a zoomed photo covering the screen (or centred on an axis it doesn't fill). */
  function clampAxis(t, size, centre, view) {
    var a = size / 2 - centre, b = view - centre - size / 2;
    return Math.max(Math.min(a, b), Math.min(Math.max(a, b), t));
  }
  function clampPan() {
    var b = V.box;
    if (V.s <= 1) { V.s = 1; V.x = 0; V.y = 0; return; }
    V.x = clampAxis(V.x, b.w * V.s, b.cx, b.vw);
    V.y = clampAxis(V.y, b.h * V.s, b.cy, b.vh);
  }

  /** Zoom to `scale`, keeping the point (px, py) under the finger where it is. */
  function zoomTo(scale, px, py, animate) {
    var b = V.box;
    if (!b) return;
    scale = Math.max(1, Math.min(MAX_SCALE, scale));
    if (px == null) { px = b.cx + V.x; py = b.cy + V.y; }
    var k = scale / V.s;
    V.x = px - b.cx - (px - b.cx - V.x) * k;
    V.y = py - b.cy - (py - b.cy - V.y) * k;
    V.s = scale;
    clampPan();
    apply(animate);
  }

  /** Zoomed-in level: enough for the photo to fill the whole screen. */
  function coverScale() {
    var b = V.box;
    return Math.max(2, Math.min(MAX_SCALE, Math.max(b.vw / b.w, b.vh / b.h)));
  }

  function toggleZoom(px, py) {
    if (V.s > 1.01) zoomTo(1, null, null, true);
    else zoomTo(coverScale(), px, py, true);
  }

  function show(index) {
    var n = V.items.length;
    if (!n) return;
    V.index = ((index % n) + n) % n;
    var item = V.items[V.index];
    layout();
    reset(false);
    V.img.alt = item.alt;
    V.img.src = item.preview || item.thumb;
    var token = V.token = {};
    var hi = new Image();
    hi.onload = function () { if (V.token === token) V.img.src = item.src; };
    hi.src = item.src;
    qsa('[data-mv-thumb]', V.strip).forEach(function (t, i) {
      var on = i === V.index;
      t.classList.toggle('is-active', on);
      if (on) {
        t.setAttribute('aria-current', 'true');
        V.strip.scrollTo({ left: t.offsetLeft - (V.strip.clientWidth - t.offsetWidth) / 2, behavior: FS.reduceMotion ? 'auto' : 'smooth' });
      } else {
        t.removeAttribute('aria-current');
      }
    });
    if (V.gallery) selectMedia(V.gallery, item.id);
  }

  function openViewer(gallery, mediaId) {
    if (!V) buildViewer();
    V.items = viewerItems(gallery);
    if (!V.items.length) return;
    V.gallery = gallery;
    var start = 0;
    V.items.forEach(function (it, i) { if (it.id === String(mediaId)) start = i; });
    V.el.classList.toggle('is-single', V.items.length < 2);
    V.strip.innerHTML = '';
    V.items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'media-viewer__thumb';
      b.dataset.mvThumb = String(i);
      b.setAttribute('aria-label', str('slide', 'Slide [number]').replace('[number]', i + 1));
      var im = document.createElement('img');
      im.src = it.thumb; im.alt = ''; im.draggable = false;
      b.appendChild(im);
      b.addEventListener('click', function () { show(i); });
      V.strip.appendChild(b);
    });
    // App widgets use the max z-index too — being last in <body> wins the tie.
    if (document.body.lastElementChild !== V.el) document.body.appendChild(V.el);
    FS.Overlay.show(V.el);
    V.open = true;
    show(start);
  }

  function closeViewer() {
    if (!V || !V.open) return;
    FS.Overlay.hide(V.el);
    afterClose();
  }
  function afterClose() {
    V.open = false; V.token = null; V.pointers = {}; V.gesture = null; V.tap = null;
    reset(false);
  }

  function pointerList() { return Object.keys(V.pointers).map(function (k) { return V.pointers[k]; }); }
  function dist(a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)) || 1; }

  function startGesture(moved) {
    var p = pointerList();
    if (p.length >= 2) {
      V.gesture = { pinch: true, d0: dist(p[0], p[1]), s0: V.s, mx: (p[0].x + p[1].x) / 2, my: (p[0].y + p[1].y) / 2, ox: V.x, oy: V.y };
    } else if (p.length === 1) {
      V.gesture = { pinch: false, sx: p[0].x, sy: p[0].y, ox: V.x, oy: V.y, t: Date.now(), moved: !!moved };
    } else {
      V.gesture = null;
    }
  }

  function onPointerDown(e) {
    V.tap = null;
    if (e.target.closest('button, [data-mv-thumbs]')) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { V.el.setPointerCapture(e.pointerId); } catch (err) { /* capture is optional */ }
    V.pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    V.img.classList.remove('is-settling');
    startGesture(false);
  }

  function onPointerMove(e) {
    var p = V.pointers[e.pointerId], g = V.gesture, b = V.box;
    if (!p || !g || !b) return;
    p.x = e.clientX; p.y = e.clientY;
    if (g.pinch) {
      var pts = pointerList();
      if (pts.length < 2) return;
      var s = Math.max(1, Math.min(MAX_SCALE, g.s0 * dist(pts[0], pts[1]) / g.d0));
      var mx = (pts[0].x + pts[1].x) / 2, my = (pts[0].y + pts[1].y) / 2;
      // The photo point that started under the fingers' midpoint stays under it.
      V.x = mx - b.cx - (g.mx - b.cx - g.ox) * s / g.s0;
      V.y = my - b.cy - (g.my - b.cy - g.oy) * s / g.s0;
      V.s = s;
      clampPan();
      apply(false);
      return;
    }
    var dx = e.clientX - g.sx, dy = e.clientY - g.sy;
    if (!g.moved && Math.abs(dx) + Math.abs(dy) > 8) g.moved = true;
    if (!g.moved) return;
    if (V.s > 1.01) { V.x = g.ox + dx; V.y = g.oy + dy; clampPan(); }
    else if (V.items.length > 1) { V.x = dx; V.y = 0; }
    apply(false);
  }

  function onPointerUp(e) {
    if (!V.pointers[e.pointerId]) return;
    delete V.pointers[e.pointerId];
    var g = V.gesture;
    if (!g) return;
    if (g.pinch) {
      if (pointerList().length === 1) { startGesture(true); return; }
      V.gesture = null;
      if (V.s < 1.1) reset(true); else { clampPan(); apply(true); }
      return;
    }
    V.gesture = null;
    if (e.type === 'pointercancel') g.moved = true;
    if (!g.moved) {
      // Acted on in the click that follows, so nothing underneath gets it.
      if (Date.now() - g.t < 400) V.tap = { x: e.clientX, y: e.clientY };
      return;
    }
    if (V.s > 1.01) return;
    var dx = e.clientX - g.sx;
    if (Math.abs(dx) > 50 && V.items.length > 1) show(V.index + (dx < 0 ? 1 : -1));
    else reset(true);
  }

  /** Tap on the photo zooms in there; tap again zooms out; tap the backdrop closes. */
  function onTap(e) {
    var tap = V.tap;
    V.tap = null;
    if (!tap || e.target.closest('button, [data-mv-thumbs]')) return;
    if (V.s > 1.01) { zoomTo(1, null, null, true); return; }
    var r = V.img.getBoundingClientRect();
    if (tap.x >= r.left && tap.x <= r.right && tap.y >= r.top && tap.y <= r.bottom) zoomTo(coverScale(), tap.x, tap.y, true);
    else closeViewer();
  }

  function onKey(e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      e.preventDefault();
      show(V.index + (e.key === 'ArrowRight' ? 1 : -1));
    } else if (e.key === 'Tab') {
      var f = qsa('button', V.el).filter(function (b) { return b.getClientRects().length; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  function initViewer(gallery, stage) {
    if (!once(stage, 'GalleryViewer')) return;
    stage.addEventListener('click', function (e) {
      if (stage._justSwiped) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) {
        return;
      }
      if (!small.matches) return;
      // Only the photo itself — not videos, 3D models or buttons laid over it.
      var img = e.target.closest('[data-zoomable]');
      var slide = img && img.closest('.product__slide.is-active');
      if (slide) openViewer(gallery, slide.dataset.mediaId);
    });
  }

  function initGalleryNav(gallery, stage) {
    if (!stage) return;
    var prevBtn = qs('[data-gallery-prev]', stage);
    var nextBtn = qs('[data-gallery-next]', stage);

    if (!prevBtn) {
      prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'product__nav product__nav--prev';
      prevBtn.setAttribute('data-gallery-prev', '');
      prevBtn.setAttribute('aria-label', str('prev', 'Previous'));
      prevBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
      stage.appendChild(prevBtn);
    }
    if (!nextBtn) {
      nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'product__nav product__nav--next';
      nextBtn.setAttribute('data-gallery-next', '');
      nextBtn.setAttribute('aria-label', str('next', 'Next'));
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg>';
      stage.appendChild(nextBtn);
    }

    if (once(prevBtn, 'GalleryNavPrev')) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepMedia(gallery, -1);
      });
    }
    if (once(nextBtn, 'GalleryNavNext')) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        stepMedia(gallery, 1);
      });
    }

    updateNavVisibility(gallery);
  }

  function initStageSwipe(gallery, stage) {
    if (!once(stage, 'StageSwipe')) return;
    var startX = 0, startY = 0, diffX = 0, diffY = 0, isTouching = false;

    stage.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    stage.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length > 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      diffX = 0;
      diffY = 0;
      isTouching = true;
    }, { passive: true });

    stage.addEventListener('touchmove', function (e) {
      if (!isTouching || !e.touches || e.touches.length > 1) return;
      diffX = e.touches[0].clientX - startX;
      diffY = e.touches[0].clientY - startY;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
        if (e.cancelable) e.preventDefault();
      }
    }, { passive: false });

    function onStageTouchEnd() {
      if (!isTouching) return;
      isTouching = false;
      var absX = Math.abs(diffX);
      var absY = Math.abs(diffY);
      var threshold = 35;
      if (absX > threshold && absX > absY) {
        stage._justSwiped = true;
        setTimeout(function () { stage._justSwiped = false; }, 350);
        if (diffX < 0) {
          stepMedia(gallery, 1);
        } else {
          stepMedia(gallery, -1);
        }
      }
      diffX = 0;
      diffY = 0;
    }

    stage.addEventListener('touchend', onStageTouchEnd, { passive: true });
    stage.addEventListener('touchcancel', onStageTouchEnd, { passive: true });

    // Desktop mouse cursor drag
    var isMouseDown = false, mouseStartX = 0, mouseStartY = 0, mouseDiffX = 0, mouseDiffY = 0;

    stage.addEventListener('mousedown', function (e) {
      if (e.button !== 0 || e.target.closest('[data-gallery-prev], [data-gallery-next]')) return;
      isMouseDown = true;
      mouseStartX = e.clientX;
      mouseStartY = e.clientY;
      mouseDiffX = 0;
      mouseDiffY = 0;
      stage.classList.add('is-dragging');
    });

    window.addEventListener('mousemove', function (e) {
      if (!isMouseDown) return;
      mouseDiffX = e.clientX - mouseStartX;
      mouseDiffY = e.clientY - mouseStartY;
      if (Math.abs(mouseDiffX) > 10) {
        e.preventDefault();
        var lens = qs('.product__zoom-lens', stage);
        var pane = qs('.product__zoom-pane', gallery);
        if (lens) lens.hidden = true;
        if (pane) pane.hidden = true;
      }
    });

    function onStageMouseUp() {
      if (!isMouseDown) return;
      isMouseDown = false;
      stage.classList.remove('is-dragging');
      var absX = Math.abs(mouseDiffX);
      var absY = Math.abs(mouseDiffY);
      var threshold = 35;
      if (absX > threshold && absX > absY) {
        stage._justSwiped = true;
        setTimeout(function () { stage._justSwiped = false; }, 350);
        if (mouseDiffX < 0) {
          stepMedia(gallery, 1);
        } else {
          stepMedia(gallery, -1);
        }
      }
      mouseDiffX = 0;
      mouseDiffY = 0;
    }

    window.addEventListener('mouseup', onStageMouseUp);

    // Desktop trackpad horizontal wheel
    var stageWheelDebounce = null, stageWheelDelta = 0;
    stage.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY) && Math.abs(e.deltaX) > 20) {
        stageWheelDelta += e.deltaX;
        if (stageWheelDebounce) clearTimeout(stageWheelDebounce);
        stageWheelDebounce = setTimeout(function () {
          if (Math.abs(stageWheelDelta) > 30) {
            if (stageWheelDelta > 0) {
              stepMedia(gallery, 1);
            } else {
              stepMedia(gallery, -1);
            }
          }
          stageWheelDelta = 0;
        }, 60);
      }
    }, { passive: true });
  }

  function notifyColorChange(gallery, colorName, isUserAction) {
    if (!gallery) gallery = qs('[data-gallery]');
    if (!gallery) return;
    var stage = qs('[data-gallery-stage]', gallery);
    if (!stage) return;

    // Immediate clean transition without reflow delay

    // 3. Floating visual indicator badge on stage
    var badge = qs('[data-stage-indicator]', stage);
    if (!badge) {
      badge = document.createElement('div');
      badge.className = 'product__stage-indicator';
      badge.setAttribute('data-stage-indicator', '');
      badge.setAttribute('aria-live', 'polite');
      badge.innerHTML =
        '<span class="stage-indicator__icon">' +
          '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
            '<path d="M2.5 8.5l3.5 3.5 7.5-7.5"/>' +
          '</svg>' +
        '</span>' +
        '<span class="stage-indicator__text">' +
          'Color: <strong data-stage-indicator-color></strong>' +
        '</span>';
      stage.appendChild(badge);
    }
    var colorTxt = qs('[data-stage-indicator-color]', badge);
    if (colorTxt && colorName) colorTxt.textContent = colorName;

    badge.classList.remove('is-visible');
    void badge.offsetWidth;
    badge.classList.add('is-visible');

    if (badge._hideTimer) clearTimeout(badge._hideTimer);
    badge._hideTimer = setTimeout(function () {
      badge.classList.remove('is-visible');
    }, 2400);

    // 4. Mobile view (<= 993px): scroll gallery into view ONLY on manual user action (never on product open / load)
    if (isUserAction && !window._isInitialProductLoad && window.innerWidth <= 993) {
      var rect = stage.getBoundingClientRect();
      if (rect.bottom < 180 || rect.top < -30) {
        stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    // 5. Reset thumbnail rail scroll to first image on color change
    var rail = qs('.rail, [data-gallery-thumbs]', gallery);
    if (rail) {
      rail.scrollLeft = 0;
      var w = rail.closest('.rail-wrap');
      if (w && w._updateEdges) w._updateEdges();
    }

    updateNavVisibility(gallery);
  }

  function initProductGallery(ctx) {
    qsa('[data-gallery]', ctx).forEach(function (gallery) {
      if (!once(gallery, 'Gallery')) return;
      var stage = qs('[data-gallery-stage]', gallery);
      if (stage) {
        initZoom(gallery, stage);
        initViewer(gallery, stage);
        initGalleryNav(gallery, stage);
        initStageSwipe(gallery, stage);
      }

      thumbs(gallery).forEach(function (t) {
        var pick = function () {
          window._isInitialProductLoad = false;
          selectMedia(gallery, t.dataset.thumb, false);
        };

        t.addEventListener('mouseenter', pick);
        t.addEventListener('focus', pick);
        t.addEventListener('click', pick);
      });
    });

    if (once(document.body, 'GallerySwatchListener')) {
      document.addEventListener('click', function (e) {
        var swatch = e.target.closest('[data-color-swatch]');
        if (!swatch) return;
        window._isInitialProductLoad = false;
        var colorVal = swatch.getAttribute('data-color-value');
        var g = galleryFor(swatch);
        if (g && colorVal) {
          setTimeout(function () {
            notifyColorChange(g, colorVal, true);
          }, 30);
        }
      });
    }
  }

  window.FS.ProductGallery = { selectMedia: selectMedia, selectFirstVisible: selectFirstVisible, galleryFor: galleryFor, notifyColorChange: notifyColorChange, stepMedia: stepMedia };
  window.FS.initProductGallery = initProductGallery;
})();
